module.exports = __webpack_public_path__ + "static/img/图层 45.48ed8b0f.png";